<template>
  <MetricTile
    v-if="density === 'default'"
    :loading="loading"
    :no-data="!metric || !metric.total"
    :progress-bar-value="metric?.percentage"
    :options="{
      showAdditionalData: true,
      showDuration: false
    }"
    icon="fa fa-ticket"
    color="orange"
    data-pw="metricTile">
    <template #title>Licenses Used</template>
    <template #metric-title>{{ $t("components.AccessCodesUsageRatioMetricTile.metric_title") }}</template>
    <template #metric>{{ metric.completed }}</template>
    <template #overMetric>{{ metric.total }}</template>
    <template #additionalMetric> {{ metric.percentage }}%</template>
    <template #info>{{ $t("components.AccessCodesUsageRatioMetricTile.info") }}</template>
  </MetricTile>
  <MiniMetricTile v-else-if="density === 'compact'"  color="orange" tile-background-color="bg-orange-lighten-5" :loading="loading">
    <template #icon>
      fa fa-ticket
    </template>
    <template #metric>
      {{ metric?.completed || 0 }} / <span class="caption">{{ metric?.total || 0 }}</span>
    </template>
    <template #title>
      Licenses Used
    </template>
  </MiniMetricTile>
</template>

<script setup lang="ts">
import MetricTile from "@/components/Metrics/MetricTile.vue";
import { useMetricTile } from "@/composables/useMetricTile";
import {PropType} from "vue";
import MiniMetricTile from "@/components/Metrics/MiniMetricTile.vue";
const { metric, loading } = useMetricTile<
  {
    completed: number;
    total: number;
    ratio: number;
    percentage: number;
  }>("access-code-usage-ratio");

defineProps({
  density: {
    type: String as PropType<"default" | "compact" | "comfortable">,
    default: "default"
  },
});
</script>
